import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import RemoveGochiKidDialog from '../../components/molecules/RemoveGochiKidDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import {
  getGochiMenus,
  getGochiMenuDetail,
  removeGochiKidMenu,
  addGochiKidMenu
} from '../../actions/GochiMenus';
import { sendLogin } from '../../auth/Auth';
import ContentDialog from '../../components/molecules/ContentDialog';
import GochiKidMenuTableBodyGroup from '../../components/molecules/GochiKidMenuTableBodyGroup';
import GochiKidMenuTableHeadGroup from '../../components/molecules/GochiKidMenuTableHeadGroup';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import GochiMenuDetailGroup from './GochiMenuDetailGroup';
import AddGochiKidDialog from '../../components/molecules/AddGochiKidDialog';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  modal: {
    maxWidth: 978,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      menus: state.gochiMenus.menus,
      totalCount: state.gochiMenus.totalCount,
      offset: state.gochiMenus.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          getGochiMenuDetail,
          removeGochiKidMenu,
          addGochiKidMenu
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEdit', 'updateOpenEdit', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openRemove', 'updateOpenRemove', false),
  withState('loading', 'updateLoading', false),
  withState('isSuccess', 'updateIsSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuChildType', 'setMenuChildType', 0),
  withState('comboMenu', 'setComboMenu', 0),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('menuId', 'setMenuId', 0),
  withState('menuName', 'setMenuName', ''),
  withState('price', 'setPrice', ''),
  withState('priceCalc', 'setPriceCalc', '0 (税抜 0)'),
  withState('priceCombo', 'setPriceCombo', ''),
  withState('quantityRelease', 'setQuantityRelease', ''),
  withState('quantityPromotion', 'setQuantityPromotion', ''),
  withState('promotionDescription', 'setPromotionDescription', ''),
  withState('usageLimit', 'setUsageLimit', 0),
  withState('expiration', 'setExpiration', ''),
  withState('expirationEndDate', 'setExpirationEndDate', ''),
  withState('description', 'setDescription', ''),
  withState('taxType', 'setTaxType', 'EXTERNAL'),
  withState('taxTypeStr', 'setTaxTypeStr', '外税'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('reducedTaxTypeStr', 'setReducedTaxTypeStr', '対象外'),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('createdAt', 'setCreatedAt', ''),
  withState('rowsPerPage', 'setRowsPerPage', 15),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('page', 'setPage', 0),
  withState('openShowHide', 'updateOpenShowHide', false),
  withState('showHide', 'setShowHide', 1),
  withState('shashokuOptionStr', 'setShashokuOptionStr', ''),
  withState('openFullMessage', 'updateOpenFullMessage', false),
  withState('fullMessage', 'setFullMessage', ''),
  withState('message', 'setMessage', ''),
  withState('otherLanguages', 'setOtherLanguages', {}),
  withState('menuGenreId', 'setMenuGenreId', null),
  withState('menuGenreName', 'setMenuGenreName', ''),
  withState('menuSituationIds', 'setmenuSituationIds', []),
  withState('menuSituationNames', 'setMenuSituationNames', ''),
  withState('subscription', 'setSubscription', ''),
  withState('subscriptionInterval', 'setSubscriptionInterval', ''),
  withState('subscriptionIntervalCount', 'setSubscriptionIntervalCount', ''),
  withState('menuUserTargetIds', 'setmenuUserTargetIds', []),
  withState('menuUserTargetNames', 'setMenuUserTargetNames', ''),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openProgress', 'updateOpenProgress', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    roles,
    page,
    selectedPage,
    handleChangePage,
    menus,
    totalCount,
    openDetailModal,
    updateOpenDetailModal,
    openRemove,
    updateOpenRemove,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    updateOpenEdit,
    updateOpenProgress,
    loading,
    updateLoading,
    isSuccess,
    updateIsSuccess,
    resultMessage,
    setResultMessage,
    menuChildType,
    setMenuChildType,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    shopId,
    setShopId,
    shopName,
    setShopName,
    menuId,
    setMenuId,
    menuName,
    setMenuName,
    comboMenu,
    setComboMenu,
    price,
    setPrice,
    priceCombo,
    setPriceCombo,
    quantityRelease,
    setQuantityRelease,
    quantityPromotion,
    setQuantityPromotion,
    usageLimit,
    setUsageLimit,
    description,
    setDescription,
    promotionDescription,
    setPromotionDescription,
    expiration,
    setExpiration,
    expirationEndDate,
    setExpirationEndDate,
    taxType,
    setTaxType,
    taxTypeStr,
    setTaxTypeStr,
    reducedTaxType,
    setReducedTaxType,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxTypeStr,
    setReducedTaxTypeStr,
    setSubscription,
    setSubscriptionInterval,
    setSubscriptionIntervalCount,
    subscription,
    subscriptionInterval,
    subscriptionIntervalCount,
    tags,
    setTags,
    tagStr,
    setTagStr,
    image,
    setImage,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    order,
    orderBy,
    handleRequestSort,
    showHide,
    setShowHide,
    openFullMessage,
    updateOpenFullMessage,
    fullMessage,
    setShashokuOptionStr,
    shashokuOptionStr,
    setRowsPerPage,
    otherLanguages,
    setOtherLanguages,
    menuGenre,
    menuSituation,
    menuUserTarget,
    menuGenreId,
    setMenuGenreId,
    menuGenreName,
    setMenuGenreName,
    menuSituationIds,
    setmenuSituationIds,
    menuSituationNames,
    setMenuSituationNames,
    menuUserTargetIds,
    setmenuUserTargetIds,
    menuUserTargetNames,
    setMenuUserTargetNames,
    menuLimitTotal,
    setMenuLimitTotal,
    openAdd,
    updateOpenAdd,
    openProgress,
    isAddGochiKidMenu
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const detail = {
      menuChildType,
      groupId,
      groupName,
      shopId,
      shopName,
      menuId,
      menuName,
      price,
      description,
      comboMenu,
      priceCombo,
      quantityRelease,
      quantityPromotion,
      promotionDescription,
      subscriptionIntervalCount,
      subscriptionInterval,
      subscription,
      usageLimit,
      expiration,
      expirationEndDate,
      taxType,
      taxTypeStr,
      reducedTaxType,
      reducedTaxCheck,
      reducedTaxTypeStr,
      tags,
      tagStr,
      image,
      createdAt,
      updatedAt,
      shashokuOptionStr,
      showHide,
      otherLanguages,
      menuGenreName,
      menuSituationNames,
      menuUserTargetNames,
      menuGenreId,
      menuSituationIds,
      menuUserTargetIds,
      menuLimitTotal
    };
    const getGochiMenu = async id => {
      await actions.getGochiMenuDetail(id).then(detailData => {
        console.log('DETAIL: ', detailData.payload);
        checkSession(detailData);
        setMenuChildType(detailData.payload.menuChildType);
        setGroupId(detailData.payload.groupId);
        setGroupName(detailData.payload.groupName);
        setShopId(detailData.payload.shopId);
        setShopName(detailData.payload.shopName);
        setMenuId(detailData.payload.menuId);
        setMenuName(detailData.payload.menuName);
        setPrice(detailData.payload.price);
        setDescription(detailData.payload.description);
        setTaxType(detailData.payload.taxType);
        setTaxTypeStr(detailData.payload.taxTypeStr);
        setReducedTaxType(detailData.payload.reducedTaxType);
        setSubscription(detailData.payload.subscription);
        setSubscriptionInterval(detailData.payload.subscriptionInterval);
        setSubscriptionIntervalCount(
          detailData.payload.subscriptionIntervalCount
        );
        setMenuLimitTotal(detailData.payload.menuLimitTotal);
        if (detailData.payload.reducedTaxType === 'REDUCED') {
          setReducedTaxCheck(true);
          setReducedTaxTypeStr('対象');
        } else {
          setReducedTaxCheck(false);
          setReducedTaxTypeStr('対象外');
        }
        setTags(detailData.payload.tags);
        setTagStr(
          detailData.payload.tags
            .map(tag => {
              return `${tag.tagName}`;
            })
            .join(' ')
        );
        setComboMenu(detailData.payload.menuCombo);
        setPriceCombo(detailData.payload.priceCombo);
        setQuantityRelease(detailData.payload.quantity);
        setQuantityPromotion(detailData.payload.quantityFree);
        setPromotionDescription(detailData.payload.quantityFreeDes);
        setUsageLimit(detailData.payload.numberUsePerDay);
        setExpiration(detailData.payload.expiration);
        setExpirationEndDate(detailData.payload.expirationEndDate);
        setImage(detailData.payload.image);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
        console.log('PAYLOAD: ', detailData.payload);
        const shashokuOptionArr = [];
        if (detailData.payload.gochimeshiFlag === 1) {
          shashokuOptionArr.push('ごちめし（さきめし含む）');
        }
        if (detailData.payload.shashokuFlag === 1) {
          shashokuOptionArr.push('社食ごちめし');
        }
        if (detailData.payload.gochiKidFlag === 1) {
          shashokuOptionArr.push('こどもごちめし');
        }
        setShashokuOptionStr(shashokuOptionArr.join(', '));
        setShowHide(detailData.payload.showHide);
        setOtherLanguages(detailData.payload.otherLanguages);

        if (detailData.payload.menuGenreId) {
          setMenuGenreId(detailData.payload.menuGenreId);
          setMenuGenreName(
            menuGenre.find(
              genre =>
                genre.menuGenreId.toString() ===
                detailData.payload.menuGenreId.toString()
            ).menuGenreName
          );
        } else {
          setMenuGenreId(null);
          setMenuGenreName('');
        }

        if (
          detailData.payload.menuSituationIds &&
          detailData.payload.menuSituationIds.length
        ) {
          const userTargetNames = [];
          detailData.payload.menuUserTargetIds.forEach(userTargetId => {
            const userTargetname = menuUserTarget.find(
              userTarget =>
                userTarget.menuUserTargetId.toString() ===
                userTargetId.toString()
            ).name;
            userTargetNames.push(userTargetname);
          });
          setmenuUserTargetIds(detailData.payload.menuUserTargetIds);
          setMenuUserTargetNames(userTargetNames.join(', '));
        } else {
          setmenuUserTargetIds([]);
          setMenuUserTargetNames('');
        }
        if (
          detailData.payload.menuSituationIds &&
          detailData.payload.menuSituationIds.length
        ) {
          const situationNames = [];
          detailData.payload.menuSituationIds.forEach(situationId => {
            const situationName = menuSituation.find(
              situation =>
                situation.menuSituationId.toString() === situationId.toString()
            ).menuSituationName;
            situationNames.push(situationName);
          });
          setmenuSituationIds(detailData.payload.menuSituationIds);
          setMenuSituationNames(situationNames.join(', '));
        } else {
          setmenuSituationIds([]);
          setMenuSituationNames('');
        }
      });
    };
    const detailOpenAction = params => {
      updateLoading(true);
      updateOpenProgress(true);
      getGochiMenu(params.id)
        .then(() => {
          updateOpenProgress(false);
          updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          updateOpenProgress(false);
          updateLoading(false);
        });
    };

    const removeOpenAction = id => {
      updateOpenRemove(true);
      setTargetRowId(id);
    };
    const cancelAction = () => updateOpenRemove(false);
    const removeAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const removeMenu = await actions
        .removeGochiKidMenu(targetRowId, { gochiKidFlag: 0 })
        .then(data => checkSession(data));
      if (removeMenu.type === 'REMOVE_GOCHI_KID_MENU_SUCCESS') {
        updateIsSuccess(true);
        handleChangePage(null, selectedPage, rowsPerPage);
        setResultMessage('更新に完了しました。');
        updateLoading(false);
      } else {
        updateIsSuccess(false);
        setResultMessage('更新に失敗しました。もう一度やり直してください。');
        updateLoading(false);
      }
    };

    const addOpenAction = id => {
      updateOpenAdd(true);
      setTargetRowId(id);
    };
    const cancelAddAction = () => updateOpenAdd(false);
    const addAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const params = {
        gochiKidFlag: 1
      };
      const addGochiKid = await actions
        .addGochiKidMenu(targetRowId, params)
        .then(data => checkSession(data));
      if (addGochiKid.type === 'ADD_GOCHI_KID_MENU_SUCCESS') {
        updateIsSuccess(true);
        handleChangePage(null, selectedPage, rowsPerPage);
        setResultMessage('更新に完了しました。');
        updateLoading(false);
      } else {
        updateIsSuccess(false);
        setResultMessage('更新に失敗しました。もう一度やり直してください。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isSuccess) {
        updateOpenRemove(false);
        updateOpenAdd(false);
        updateOpenDetailModal(false);
      }
      updateOpenProgress(false);
      updateLoading(false);
    };

    return (
      <div>
        <ExPaginationGroup
          count={
            totalCount % rowsPerPage > 0
              ? Math.floor(totalCount / rowsPerPage) + 1
              : Math.floor(totalCount / rowsPerPage)
          }
          selectedPage={selectedPage}
          handleChangePage={handleChangePage}
          limit={rowsPerPage}
          totalCount={totalCount}
          setLimit={setRowsPerPage}
          hideRowsPerPage
        />
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GochiKidMenuTableHeadGroup
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              roles={roles}
            />
            <GochiKidMenuTableBodyGroup
              menus={menus}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              detailOpenAction={detailOpenAction}
              removeOpenAction={removeOpenAction}
              order={order}
              orderBy={orderBy}
              addOpenAction={addOpenAction}
              isAddGochiKidMenu={isAddGochiKidMenu}
            />
          </Table>
        </div>
        <div>
          <ExPaginationGroup
            count={
              totalCount % rowsPerPage > 0
                ? Math.floor(totalCount / rowsPerPage) + 1
                : Math.floor(totalCount / rowsPerPage)
            }
            selectedPage={selectedPage}
            handleChangePage={handleChangePage}
            limit={rowsPerPage}
            totalCount={totalCount}
            hideRowsPerPage
          />
        </div>
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
          className={classes.modal}
        >
          <GochiMenuDetailGroup
            updateOpenDetailModal={updateOpenDetailModal}
            updateOpenEditModal={updateOpenEdit}
            detail={detail}
            menuGenre={menuGenre}
            menuSituation={menuSituation}
            menuUserTarget={menuUserTarget}
          />
        </Modal>
        <RemoveGochiKidDialog
          openRemove={openRemove}
          updateOpenRemove={updateOpenRemove}
          cancelAction={cancelAction}
          removeAction={removeAction}
          targetRowId={targetRowId}
          target=""
        />
        <AddGochiKidDialog
          openAdd={openAdd}
          updateOpenAdd={updateOpenAdd}
          cancelAction={cancelAddAction}
          addAction={addAction}
        />
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <ContentDialog
          openContent={openFullMessage}
          updateOpenContent={updateOpenFullMessage}
          content={fullMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
